<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="['d-flex', getSelectedDEV && 'dev-selected-component']">
    <i4pro-icon-popover
      v-if="schema.attributesInfo"
      :class="[schema.attributesInfo.right ? 'ml-1 order-2' : 'mr-1']"
      :schema="schema"
      :model="model"
    ></i4pro-icon-popover>
    <v-textarea
      :rules="rules"
      :name="schema.model"
      :id="setId(schema.model)"
      v-bind="schema.attributesTextField"
      :readonly="schema.readonly"
      v-model="value"
      :ref="schema.model"
      @blur="onBlur"
      @click:clear="clear()"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
    >
      <template v-slot:label>
        {{ schema.attributesTextField.label }}
        <span v-if="schema.rules.includes('required')" class="red--text">*</span>
      </template>
    </v-textarea>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin],

  components: {
    i4proIconPopover: () => import('@/components/icons/i4pro-icon-popover')
  },

  methods: {
    async onBlur() {
      this.changeEvents();
    },

    clear() {
      this.$nextTick(() => (this.model[this.schema.model] = ''));
    },
    setId(field) {
      return this.formOptions.mode === 'list' ? `${field}_${this.formOptions.index}` : field;
    }
  }
};
</script>
